// extracted by mini-css-extract-plugin
export default {"link-container":"NpM_qu","linkContainer":"NpM_qu","link-fade-in":"XdHhfx","linkFadeIn":"XdHhfx","icon":"arCcr8","ltr":"LsXYo7","rtl":"Ov5vD5"};